import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ApiUrl } from './apiUrl';

@Injectable({
  providedIn: 'root'
})
export class MobileClientDiagnosticService {

  constructor(private apiService: ApiService) {}

  listDiagnostics(params: Record<string, string | number> = {}): Observable<any> {
    const queryParams = new URLSearchParams(
      Object.entries(params).reduce((acc, [key, value]) => {
        if (value !== '' && value != null) {
          acc[key] = String(value);
        }
        return acc;
      }, {} as Record<string, string>)
    ).toString();
    const url = queryParams
      ? `${ApiUrl.mobileClientDiagnostics}?${queryParams}`
      : ApiUrl.mobileClientDiagnostics;
    return this.apiService.getRequest(url);
  }

  getDiagnosticDetail(id: string): Observable<any> {
    return this.apiService.getRequest(ApiUrl.mobileClientDiagnosticById(id));
  }

  getSessionTimeline(diagnosticSessionId: string): Observable<any> {
    return this.apiService.getRequest(
      ApiUrl.mobileClientDiagnosticSession(diagnosticSessionId)
    );
  }

  getAdoption(params: Record<string, string> = {}): Observable<any> {
    const queryParams = new URLSearchParams(
      Object.entries(params).reduce((acc, [key, value]) => {
        if (value) {
          acc[key] = value;
        }
        return acc;
      }, {} as Record<string, string>)
    ).toString();
    const url = queryParams
      ? `${ApiUrl.mobileClientDiagnosticsAdoption}?${queryParams}`
      : ApiUrl.mobileClientDiagnosticsAdoption;
    return this.apiService.getRequest(url);
  }
}
